import React from 'react'
import { Page, Document, StyleSheet, Image} from '@react-pdf/renderer';
import InvoiceItemsTable from './pdf/InvoiceItemsTable';
import InvoiceTitle from './pdf/InvoiceTitle';
import InvoiceItemsTableList from './pdf/InvoiceItemsTableList';

import Sign from './pdf/sign';
import moment from 'moment';
import 'moment/locale/es';
import InvoiceItemsTableListEmpresa from './pdf/InvoiceItemsTableListEmpresa';
import { Hidden } from '@mui/material';

function getRealAge(dateString) {
    
    if(!dateString || dateString == null) {
        return "";
    }
var starts = moment(dateString);
var ends   = moment();
var duration = moment.duration(ends.diff(starts));

return duration.years() + " años "+ duration.months()  +" meses";
}

export default function HistoryEmpresaLaboralPDF(props) {
    const styles = StyleSheet.create({
        page: {
            fontFamily: 'Helvetica',
            fontSize: 11,
            paddingTop: 30,
            paddingLeft:60,
            paddingRight:60,
            lineHeight: 1.5,
            flexDirection: 'column',
        }, 
        logo: {
            width: '100%',
            height: 'auto',
        }
      }); 
    let originInfo = props.affiliateInfo.evolutions;
     const personalInfo = [
     {
        id: 1,
        key: "NOMBRE:",
        value: props.affiliateInfo.patient.firstName + " "  +
            `${props.affiliateInfo.patient.secondName || ''}` + " "  +
             props.affiliateInfo.patient.lastName + " "  +
            `${props.affiliateInfo.patient.secondLastName || ''}` 
     },
     {
        id: 2,
        key: "TIPO IDENTIFICACIÓN:",
        value: props.affiliateInfo.patient.typeId
    },
     {
         id: 3,
         key: "IDENTIFICACIÓN:",
         value: props.affiliateInfo.patient.id
     },
     {
         id: 4,
         key: "EPS:",
         value: props.affiliateInfo.patient.eps
     },
     {
        id: 5,
        key: "REGIMEN:",
        value: props.affiliateInfo.patient.regimen
    },
     {
         id: 6,
         key: "EDAD:",
         value: getRealAge(props.affiliateInfo.patient.birthday) 
     },
    
     {
         id: 6,
         key: "TELEFONO:",
         value: props.affiliateInfo.patient.cellphone
     },
 
     {
         id: 7,
         key: "DIRECCION:",
         value: props.affiliateInfo.patient.address
     },
 
     {
         id: 8,
         key: "MUNICIPIO:",
         value: props.affiliateInfo.patient.residenceCode
     }
    ]

    const generalities = [
        {
            id: 1,
            key: "MOTIVO DE LA CONSULTA:",
            value: originInfo[props.indexEvolution].generalities.reason
        },
        {
            id: 2,
            key: "ENFERMEDAD ACTUAL:",
            value: originInfo[props.indexEvolution].generalities.illness
        },
        {
            id: 3,
            key: "CAUSA EXTERNA:",
            value: originInfo[props.indexEvolution].generalities.externalCause
        }
    ]
    const contingencias = [
        {
            id: 1,
            key: "CONTINGENCIA:",
            value: originInfo[props.indexEvolution].contintegnciasType.accidenteTrabajo
        },
        
        {
            id: 2,
            key: "ORIGEN:",
            value: originInfo[props.indexEvolution].contintegnciasType.origen
        }
    ]
    const plan = [
        {
            id: 1,
            key: "DESCRIPCIÓN DEL PLAN:",
            value: originInfo[props.indexEvolution].plan.descriptions
        }
    ]

    const physicalExam = [
        
       
        {
            id: 1,
            key: "1. CABEZA:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.head
        },
       
        {
            id: 2,
            key: "2. CUELLO:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.neck
        },
        {
            id: 3,
            key: "3. TORAX:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.chest
        },
        {
            id: 4,
            key: "4. ABDOMEN:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.abdomen
        },
        {
            id: 5,
            key: "5. GENITOURINARIO:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.genitourinary
        },
        {
            id: 6,
            key: "6. OSTEOMUSCULAR  MIEMBRO SUPERIOR:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.musculoskeletal
        },
        {
            id: 7,
            key: "7. OSTEOMUSCULAR MIEMBRO INFERIOR:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.generalAspect
        },
        {
            id: 8,
            key: "8. PIEL Y FAERAZ:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.skin
        },
        {
            id: 9,
            key: "9. NEUROLÓGICO:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.neurological
        },
        {
            id: 10,
            key: "10. GONOMETRIA PASIVA:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.visualAcuity
        }
    ]


    const reintegro = [
        {
            id: 1,
            key: "TIPO: ",
            value: originInfo[props.indexEvolution].tipoReintegro
        }
    ]

    const incapacidad = [
        {
            id: 1,
            key: "Desde: ",
            value:  moment(originInfo[props.indexEvolution].desde).locale('es').format('MMMM D YYYY')
        },
        {
            id: 2,
            key: "Hasta: ",
            value: moment(originInfo[props.indexEvolution].hasta).locale('es').format('MMMM D YYYY') 
        }
    ]

    const recomendaciones = [
        {
            id: 1,
            key: "",
            value: originInfo[props.indexEvolution].conclusiones
        }
    ]

    
    
    

    const diagnoses = [['#',"CIE10", "DESCRIPCIÓN",  "CLASE DIAGNOSTICO"] ]
    originInfo[props.indexEvolution].diagnoses.map( (item, index) => {
        diagnoses.push([index + 1, item.id, item.description, item.classDiagnosis ])
    }
    )

    const remisiones = []
    originInfo[props.indexEvolution].referrals.map( (item, index) => 
    remisiones.push(
    {
       id: index,
       key: "REMITIDO A:",
       value: item.description
    },
    {
       id: index + 20,
       key: "OBSERVACIONES:",
       value: item.observations
    }
   )
   )


 

   const treatments = [['#',"CANTIDAD", "MEDICAMENTO",  "FORMULA"] ]
   originInfo[props.indexEvolution].treatments.map( (item, index) => {
       treatments.push([index + 1, item.quantity, item.description, 
    "Cada " +item.every +" " + item.everyTime+ " durante "+ item.duration + " " + item.durationTime ])
   }
   )
  
    const companies = [['#',"Nombre", "Cargo",  "Antiguedad", "R Fisicos", "R Quimicos", "R Biologicos", "Ergonomicos", "Psicosociales"] ]
    originInfo[props.indexEvolution].companies.map( (item, index) => {
        companies.push([index + 1, item.companyName, item.occupation, item.yearsWorking, 
            item.fisicos ? 'SI' : 'NO',
            item.quimicos ? 'SI' : 'NO',
            item.biologicos ? 'SI' : 'NO',
            item.ergonomicos ? 'SI' : 'NO',
            item.psicosociales ? 'SI' : 'NO',
         ])
    }
    )

let dateAttend = props.affiliateInfo.evolutions[props.indexEvolution].assessmentDate;
        return (
            <Document title={"HC_" + personalInfo[0].value + "_" + moment(dateAttend).locale('es').format('MMMM D YYYY')}>
           
            <Page size="A4" style={styles.page}>

                <Image style={styles.logo} src="https://my-market-mompos-online.s3.amazonaws.com/medisas-resource/logo_pdf_2.png"></Image>
                <InvoiceTitle title='HISTORIA CLINICA' dateAttend={props.affiliateInfo.evolutions[props.indexEvolution].assessmentDate}/>
                <InvoiceItemsTable items={personalInfo} title={"DATOS DE IDENTIFICACION DEL USUARIO"}  separator={2} />
                <InvoiceItemsTable items={generalities} title={"GENERALIDADES DE LA CONSULTA"}  separator={1} />
                
                <InvoiceItemsTableListEmpresa items={companies} title={"EMPRESAS"}  separator={7} />
                <InvoiceItemsTable items={contingencias} title={"TIPO DE CONTINGENCIA"}  separator={1} />
                <InvoiceItemsTable items={plan} title={"PLAN"}  separator={1} />
                <InvoiceItemsTable items={physicalExam} title={"EXAMEN FÍSICO"}  separator={1} />
           
                <InvoiceItemsTableList items={diagnoses} title={"IMPRESIÓN DIAGNÓSTICA"}  separator={2} />
                <InvoiceItemsTableList items={treatments} title={"ORDEN DE MEDICAMENTOS E INDICACIONES"}  separator={2} />
                <InvoiceItemsTable items={remisiones} title={"REMISIÓN(ES)"}  separator={1} />
           
                <InvoiceItemsTable items={reintegro} title={"TIPO DE REINTEGRO"}  separator={1} />
                <Hidden xsUp={!originInfo[props.indexEvolution].useBarthel}>
                 <InvoiceItemsTable items={incapacidad} title={"INCAPACIDAD"}  separator={1} />
                </Hidden>
                <InvoiceItemsTable items={recomendaciones} title={"RECOMENDACIONES"}  separator={1} />
               
                
                
                <Sign medical={props.affiliateInfo.medicalTeam} patient={props.affiliateInfo.patient} />
            </Page>
          </Document>
        )
    };